// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Media from '../views/Media.vue';
import LoveLife from '../components/LoveLife.vue';
import Family from '../components/Family.vue';
import Jokes from '../components/Jokes.vue';
import Stories from '../components/Stories.vue';
import FoodForThought from '../components/FoodForThought.vue';
import Poems from '../views/Poems.vue';
import Joy from '../views/Joy.vue';
import Smoke from '../views/Smoke.vue';
import Math from '../views/Math.vue';
import Word from '../views/Word.vue';
import Drink from '../views/Drink.vue';



const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/media',
    name: 'Media',
    component: Media,
  },
  {
    path: '/love-life',
    name: 'LoveLife',
    component: LoveLife,
  },
  {
    path: '/family',
    name: 'Family',
    component: Family,
  },
  {
    path: '/jokes',
    name: 'Jokes',
    component: Jokes,
  },
  {
    path: '/stories',
    name: 'Stories',
    component: Stories,
  },
  {
    path: '/food-for-thought',
    name: 'FoodForThought',
    component: FoodForThought,
  },
  {
    path: '/poems',
    name: 'Poems',
    component: Poems,
  },
  {
    path: '/joy',
    name: 'Joy',
    component: Joy,
  },
  {
    path: '/smk',
    name: 'Smoke',
    component: Smoke,
  },
  {
    path: '/math',
    name: 'Math',
    component: Math,
  },
{
    path: '/word',
    name: 'Word',
    component: Word,
},
{
    path: '/drink',
    name: 'Drink',
    component: Drink,
}
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
